// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"86c1d800","455":"fdd1deb3","977":"dca2e0bc"}[chunkId] + ".chunk.js";
};